export const formContent = {
    heading: 'Event details',
    eventDate: {
        id: 'eventDate',
        label: 'Event date',
        disabled: true
    },
    eventBudget: {
        id: 'Budget',
        label: 'Budget',
        type: 'number',
        validation: {
            required: "Please enter budget"
        }
    },
    eventDescription: {
        id: 'description',
        label: 'Event description',
        validation: {
            required: "Event description is required"
        }
    },
    eventAddress: {
        id: 'address',
        label: 'Location',
        validation: {
            required: "Event address is required"
        },
        addressType:'address'
    },
    state: {
        id: 'state',
        type: 'hidden'
    },
    latitude: {
        id: 'latitude',
        type: 'hidden'
    },
    longitude: {
        id: 'longitude',
        type: 'hidden'
    }
}
